import {stringify} from 'querystring';
import Cookies from 'js-cookie';
export default class events_detail extends EventedClass {
    constructor() {
        super();
        this.elem = {
            //BODY
            document_body: $('body'),
            // PAYMENT IFRAME
            payment_iframe : $('.page-payment-frame'),
            // SECTIONS LOGIN
            section_login: $('#section-login'),
            btn_login: $('#btn-login'),
            // LOGOUT
            btn_logout: $('#btn-logout'),
            // SECTIONS REGISTER
            section_register: $('#section-register'),
            btn_register: $('#btn-register'),
            // SESSION
            form_sessions: $('form.form-session')
        }
        // CALLING INSTALL
        this.initialize();
    }

    initialize() {
        this._installEvents()
    }
    _installEvents() {
        const self = this;
        // LOGIN
        this.elem.btn_login.on('click',this._onClickLogin.bind(this))
        // REGISTER
        this.elem.btn_register.on('click',this._onClickRegister.bind(this))
        // FORM SESSION
        this.elem.form_sessions.on("submit",this._onSubmitFormSession.bind(this))
        // MESSAGES FROM PARENT
        window.addEventListener('message', function(e) {
            const message = e.data;
            if ( message.hasOwnProperty('action') && message.action == "close_frame"){
                self.elem.document_body.removeClass('lock-scroll')
                self.elem.payment_iframe.removeClass('open')
            }
        });
    }
    _onClickLogin(e){
        this.elem.section_login.removeClass('hide')
        this.elem.section_register.addClass('hide')
        // RESETS
        this.elem.section_register.find('#alert-message-register').addClass('hide').removeClass('alert-success alert-warning').empty()
        const form = this.elem.section_register.find('form#register')
        form[0].reset()
        form.find("input.is-invalid").removeClass('is-invalid')
        form.find('.invalid-feedback').remove()
    }
    _onClickRegister(e){
        this.elem.section_login.addClass('hide')
        this.elem.section_register.addClass('open').removeClass('hide')
        // RESETS
        const form = this.elem.section_login.find('form#login')
        form[0].reset()
        form.find("input.is-invalid").removeClass('is-invalid')
        form.find('.invalid-feedback').remove()
    }
    _onSubmitFormSession(e){
       if (window.isLogged){
           this.elem.document_body.addClass('lock-scroll')
           this.elem.payment_iframe.addClass('open')
           return true;
       }else{
           App.utils.notify.warning(App.messages.global.sessionTpvLogout, 'Informació', {
               timeOut: 3000,
               positionClass: 'toast-top-full-width',
               preventDuplicates: true
           })
           return false;
       }
    }
}